import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import FilterSelectItem from '../../../../molecules/FilterSelectItem';
export function MultiSelect({ name, filters, setFilter, options, translateLabels, }) {
    const { t } = useTranslation();
    const optionsMemoized = useMemo(() => {
        //
        // If it looks like an array `any[]`
        // ["open","gesloten",null,{key,value}]
        //
        if (Array.isArray(options)) {
            //
            // If it looks like an array of numbers `number[]` or `string[]`
            // [2015,2016] or ['open', 'closed']
            //
            if (options.some(v => ['number', 'string'].indexOf(typeof v))) {
                return options.map(value => ({
                    value: `${value}`,
                    label: translateLabels
                        ? t(`dossier.filters.${name}.values.${value}`)
                        : `${value}`,
                }));
            }
        }
        //
        // If it looks like an object `{}[]`
        // {}
        //
        if (typeof options === 'object') {
            return Object.entries(options).map(([value, label]) => ({
                value: `${value}`,
                label: `${label}`,
            }));
        }
        //
        // If we don't know what we're dealing with then throw an error.
        //
        throw new Error(`Can not determine option type for ${JSON.stringify(options, null, 2)}`);
    }, [t, name, filters, setFilter, options, translateLabels]);
    return (_jsx(FilterSelectItem, { name: name, label: t(`dossier.filters.${name}.label`), placeholder: t(`dossier.filters.${name}.placeholder`), value: filters[name] || '', setFilter: setFilter(name), options: optionsMemoized, isMulti: true }));
}
